import { ButtonPosition } from '@/common/manager/position/button-position';
import { getRealizeValue } from '@/common/util/util';
export const config = {
    value: 'nextStep',
    position: [ButtonPosition.formDialog, ButtonPosition.form],
    action: (config) => {
        const { buttonConfig, formInstance, formStepInstance } = config;
        const realFormInstance = getRealizeValue(formInstance);
        if (buttonConfig && realFormInstance && formStepInstance) {
            formStepInstance.next?.();
        }
    },
};
